(function () {
  const fix = () => {
    document.querySelectorAll('[data-essential-upsell-element="subscription-offer"] *')
      .forEach(el => {
        if (el.children.length === 0 && /Bespaar\s+op elke levering/.test(el.textContent)) {
          el.textContent = el.textContent.replace(/Bespaar\s+op elke levering/, 'Bespaar 0% op elke levering');
        }
      });
  };
  fix();
  new MutationObserver(fix).observe(document.body, { childList: true, subtree: true });
})();